/**
 * Phase 6 — Redesigned Input
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export interface RdInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const RdInput = React.forwardRef<HTMLInputElement, RdInputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "w-full h-8 px-3 text-[13px] rounded-[8px]",
        "bg-[hsl(var(--rd-surface))] text-[hsl(var(--rd-text))]",
        "placeholder:text-[hsl(var(--rd-text-faint))]",
        "border border-[hsl(var(--rd-border))]",
        "transition-colors duration-[120ms]",
        "hover:border-[hsl(var(--rd-border-strong))]",
        "focus:outline-none focus:border-[hsl(var(--rd-accent-500))]",
        "focus:ring-2 focus:ring-[hsl(var(--rd-accent-ring))]",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        invalid && "border-[hsl(var(--rd-error))] focus:border-[hsl(var(--rd-error))]",
        className
      )}
      {...props}
    />
  )
);
RdInput.displayName = "RdInput";
